// @ts-expect-error
import { jitsiLocalStorage } from '@jitsi/js-utils';
import moment from "moment";
import { LANDING_PAGE } from "../../../../modules/API";
import { PAGE_AUTH } from "../../../../modules/API/route";
import { isAuthDomain } from "./helpers";
import { CONFIG_CODE } from "../constants/default";
import { isGuestTmp } from "../conference/functions";
import { SET_LOBBY_CHAT_RECIPIENT } from "../../chat/actionTypes";
import { sendMessage } from "../../chat/actions.any";
import { browser } from "../lib-jitsi-meet";
import { setIsOwnerCaption } from "../../live-caption/slice";
export function toNonAccentVietnamese(str) {
    if (str) {
        str = str.replace(/A|Á|À|Ã|Ả|Ạ|Â|Ấ|Ầ|Ẫ|Ậ|Ă|Ắ|Ằ|Ẵ|Ặ/g, "A");
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
        str = str.replace(/E|É|È|Ẽ|Ẹ|Ê|Ế|Ề|Ễ|Ệ/, "E");
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
        str = str.replace(/I|Í|Ì|Ĩ|Ị/g, "I");
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
        str = str.replace(/O|Ó|Ò|Õ|Ọ|Ô|Ố|Ồ|Ỗ|Ộ|Ơ|Ớ|Ờ|Ỡ|Ợ/g, "O");
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
        str = str.replace(/U|Ú|Ù|Ũ|Ụ|Ư|Ứ|Ừ|Ữ|Ự/g, "U");
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
        str = str.replace(/Y|Ý|Ỳ|Ỹ|Ỵ/g, "Y");
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
        str = str.replace(/Đ/g, "D");
        str = str.replace(/đ/g, "d");
        // Some system encode vietnamese combining accent as individual utf-8 characters
        str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng 
        str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
    }
    return str;
}
/**
 * Lấy giá trị config
 * @param name
 * @param configs
 * @returns value
 */
export function getConfigValue(name, configs) {
    if (!name || !configs || !configs.length)
        return '';
    const _config = configs.find(c => c?.name === name || c?.code === name);
    if (_config)
        return _config.value;
    return '';
}
/**
 * Chuyển người dùng đến home page
 * @returns
 */
export function homePage(feedback = false) {
    if (browser?.isElectron()) {
        try {
            return APP.API.notifyReadyToClose();
        }
        catch (error) {
            console.error('error: ', error);
        }
    }
    if (feedback) {
        if (isGuestTmp())
            return setTimeout(() => { window.location.href = LANDING_PAGE; }, 250);
        return setTimeout(() => { window.location.href = PAGE_AUTH; }, 250);
    }
    if (isAuthDomain(document.referrer))
        setTimeout(() => { return window.location.href = PAGE_AUTH; }, 250);
    return setTimeout(() => {
        window.location.href = LANDING_PAGE;
    }, 250);
}
/**
 * Kiểm tra điều kiện hiển thị feedback
 * @param state
 * @returns
 */
export function getValidFeedback(state) {
    const { conferenceTimestamp, roomConfig } = state['features/base/conference'];
    const enabledFeedback = getConfigValue(CONFIG_CODE.ENABLE_SHOW_FEEDBACK, roomConfig) === 'ON';
    const durationMin = parseInt(getConfigValue(CONFIG_CODE.DURATION_MEETING_MIN_TO_SHOW_FEEDBACK, roomConfig));
    let duration = 0;
    if (conferenceTimestamp)
        duration = moment().diff(moment.unix(conferenceTimestamp / 1000), 'minutes');
    return enabledFeedback && duration >= durationMin;
}
export function toString(value) {
    return `${value}`;
}
/**
 * Gửi thông báo đến người tham gia trong lobby
 * @param state
 * @param dispatch
 * @param noti
 */
export function sendNotificationToLobby(state, dispatch, noti) {
    const { knockingParticipants } = state['features/lobby'];
    knockingParticipants.forEach((p) => {
        dispatch({
            type: SET_LOBBY_CHAT_RECIPIENT,
            participant: p,
            open: true
        });
        dispatch(sendMessage(noti));
    });
}
/**
 * Kiểm tra xem Chat | ParticipantPane | ModeratorController open
 * @param state
 * @returns
 */
export function isMenuOpen(state) {
    const { isOpen: isChatOpen } = state['features/chat'];
    const { isOpen: isParticipantsPaneOpen } = state['features/participants-pane'];
    const { isOpen: isModeratorControllerOpen } = state['features/moderator-controller'];
    return isChatOpen || isParticipantsPaneOpen || isModeratorControllerOpen;
}
export function checkOwnerCaption(dispatch, state) {
    try {
        const _user = jitsiLocalStorage.getItem("user");
        if (_user) {
            const user = JSON.parse(_user);
            if (user?.username === state['features/base/conference'].roomInfo?.userHostId) {
                dispatch(setIsOwnerCaption(true));
            }
        }
    }
    catch (error) {
        console.log('[Error]', error);
    }
}
